export default __webpack_public_path__ + "3e2358e518394b71ff87637d1655b108.png";